import bodymovin from 'lottie-web';

$('.js-lottie').each(function(index, item) {
  const lottie = bodymovin.loadAnimation({
    container: item,
    renderer: 'svg',
    autoplay: false,
    loop: false,
    path: $(item).data('src')
  });
  $(item).mouseenter(function() {
    if (lottie.isPaused) {
      lottie.goToAndPlay(0);
    }
  });
});
